import React from 'react';
import Descriptions from 'antd/es/descriptions';
import { AuthenticatedContextType } from '../../context/AuthenticatedContext';
import {
  contentHeight100,
  contentStyle,
  contentStyle150,
  dataDispWidth,
  labelStyle,
  userContentStyle,
  userLabelStyle,
} from '../../css/style';
import { DeviceMaintDetail } from '../../models/data/DeviceMaint';
import dateRange, { dateformat } from '../date-range';

interface DataProps {
  userdata: AuthenticatedContextType;
  data: DeviceMaintDetail | undefined;
}

const DataDisp: React.FC<DataProps> = ({ userdata, data }) => {
  const customerName = userdata.loginCustomer?.customerName ?? '';
  const corporateCode = userdata.loginCustomer?.corporateCode ?? '';

  return (
    <div>
      {/* ユーザ情報 */}
      <Descriptions
        bordered
        column={3}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.userInfo }}
      >
        <Descriptions.Item label="ユーザ名" span={3}>
          {`${corporateCode} ◇ ${customerName}`}
        </Descriptions.Item>
      </Descriptions>
      {/* 部品情報1 */}
      <Descriptions
        // title=""
        bordered
        column={3}
        contentStyle={contentStyle150}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.deviceMaintDetail }}
      >
        <Descriptions.Item label="設備点検ID" span={1}>
          {data?.eqWorkHisId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="機器ID" span={1}>
          {data?.mstId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="機器点検ID" span={1}>
          {data?.workHisId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="機器点検名" span={2}>
          {data?.workName ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="工号" span={1}>
          {data?.jobNo ?? ''}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        // title=""
        bordered
        column={2}
        contentStyle={contentStyle}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.deviceMaintDetail }}
      >
        <Descriptions.Item label="作業種別" span={2}>
          {data?.workType ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="作業期間" span={2}>
          {dateRange(data?.workSYmd, data?.workEYmd)}
        </Descriptions.Item>
        <Descriptions.Item label="更新日" span={2}>
          {dateformat(data?.revDate)}
        </Descriptions.Item>
        <Descriptions.Item
          label="機器点検内容"
          span={2}
          contentStyle={{ ...contentStyle, ...contentHeight100 }}
        >
          {data?.workHisSummary ?? ''}
        </Descriptions.Item>
        <Descriptions.Item
          label="点検実施項目"
          span={2}
          contentStyle={{ ...contentStyle, ...contentHeight100 }}
        >
          {data?.workInspectItem ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="機器別報告書No." span={2}>
          {data?.deviceReportNo ?? ''}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default DataDisp;
